import {createSlice} from "@reduxjs/toolkit";
import {CommonTableState, updateTableState} from "./general/commonTableSliceFeatures";

type PaymentCouponSlice = CommonTableState;

const initialState: PaymentCouponSlice = {
    tableState: {
        resetIndicator: 0,
        sorting: [{id: "created", desc: true}],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: ["code", "description", "partner", "discountRate", "discountRate", "validFrom", "validTo", "created", "mrt-row-actions"],
        density: "compact",
    },
};

export const paymentCouponSlice = createSlice({
    name: "paymentCoupon",
    initialState: initialState,
    reducers: {
        updatePaymentCouponTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updatePaymentCouponTableState} = paymentCouponSlice.actions;

export default paymentCouponSlice.reducer;
